export const parseJSON = <T>(data: string): T => JSON.parse(data);
